import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { EXTRA_TYPES } from "@/lib/constants";
import { EMPTY_EXTRA } from "@/lib/booking";
import { money } from "@/lib/format";
import { cn } from "@/lib/utils";

export const DriverExtras = ({ form, set, errors }) => {
  const extras = form.driver_extras;
  const update = (i, patch) => set("driver_extras", extras.map((e, j) => (j === i ? { ...e, ...patch } : e)));
  const total = extras.reduce((s, e) => s + (Number(e.amount) || 0), 0);
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/60 p-4" data-testid="driver-extras">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold text-slate-800">Driver extras</div>
          <div className="text-xs text-slate-500">Extra charges added by the removalist on the day. “Wrapping” is split driver / company per Settings → Pay rates.</div>
        </div>
        <div className="text-right">
          <div className="text-xs text-slate-500">Total driver extras</div>
          <div className="font-mono text-base font-semibold text-slate-900" data-testid="calc-extras">{money(total)}</div>
        </div>
      </div>
      <div className="space-y-2">
        {extras.map((e, i) => (
          <div key={i} className="grid grid-cols-[1fr_auto] gap-2 sm:grid-cols-[180px_1fr_130px_auto]" data-testid={`extra-row-${i}`}>
            <select value={e.type} onChange={(ev) => update(i, { type: ev.target.value })} data-testid={`extra-type-${i}`} className="h-10 rounded-md border border-slate-200 bg-white px-2 text-sm">
              {EXTRA_TYPES.map((t) => <option key={t}>{t}</option>)}
            </select>
            <Button type="button" variant="ghost" size="icon" onClick={() => set("driver_extras", extras.filter((_, j) => j !== i))} data-testid={`extra-remove-${i}`} className="text-slate-400 hover:text-rose-600 sm:order-last"><X className="h-4 w-4" /></Button>
            <Input value={e.description} onChange={(ev) => update(i, { description: ev.target.value })} placeholder="Description, e.g. Marble table" data-testid={`extra-description-${i}`} className="h-10 bg-white" />
            <div className="relative">
              <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">$</span>
              <Input value={e.amount} onChange={(ev) => update(i, { amount: ev.target.value })} inputMode="decimal" placeholder="0.00" data-testid={`extra-amount-${i}`} className={cn("h-10 bg-white pl-7 font-mono", errors[`extra_amount_${i}`] && "border-rose-400")} />
            </div>
          </div>
        ))}
      </div>
      <Button type="button" variant="outline" size="sm" onClick={() => set("driver_extras", [...extras, { ...EMPTY_EXTRA }])} data-testid="btn-add-extra" className="mt-3 border-dashed">
        <Plus className="h-4 w-4" /> Add Driver Extra
      </Button>
    </div>
  );
};
